import React, { FunctionComponent, useState } from "react"
import { RunModelDto } from "@store/services/modelsService"
import { Collapse, Typography } from "@mui/material"
import Card from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import { ExpandLess, ExpandMore } from "@mui/icons-material"
import InfoIcon from "@mui/icons-material/Info"
import Grid from "@mui/material/Grid"
import { formatTimestepDate } from "@utils/format/pythonicFormat"

interface Props {
  model: RunModelDto | undefined
  runName: string | undefined
  samples: number
  seed: number
  simulationFrequency?: string
  version?: string
  rungroup?: string
  open?: boolean
}

export const ModelAndRunMetadataCard: FunctionComponent<Props> = ({
  model,
  runName,
  samples,
  seed,
  simulationFrequency,
  version,
  rungroup,
  open = true,
}) => {
  const left = [
    ["Samples", samples],
    ["Seed", seed],
    ["Simulation Frequency", simulationFrequency],
    ["Creator", model?.creator_email],
    ["RunGroup", rungroup],
  ]
  if (model?.timesteps?.length == 2) {
    // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
    left.push(["End Date", formatTimestepDate(model.timesteps[1])])
  }

  const right = [
    ["Base", model?.graph_key.replaceAll("#", " → ")],
    ["Version", version],
    ["Scenario", model?.scenario_key],
    ["Creation Date", model?.creation_date],
    ["Description", model?.description],
  ]
  if (model?.timesteps?.length == 2) {
    // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
    right.push(["Start Date", formatTimestepDate(model.timesteps[0])])
  }

  const [isExpanded, setIsExpanded] = useState(open)

  const handleExpandCollapseClick = () => {
    setIsExpanded(!isExpanded)
  }

  return (
    <Card sx={{ width: "100%", boxShadow: "none", borderRadius: "5px !important" }}>
      <CardContent
        sx={{
          paddingBottom: "5px !important",
          padding: "5px",
          mb: "0px",
          mt: "0px",
          cursor: "pointer",
          ":hover": { backgroundColor: "#f7f7f7" },
          borderBottom: "1px solid #e7e7e7",
        }}
        onClick={handleExpandCollapseClick}
      >
        {isExpanded ? (
          <ExpandMore sx={{ verticalAlign: "middle", marginTop: "-3px" }} />
        ) : (
          <ExpandLess sx={{ verticalAlign: "middle", marginTop: "-3px" }} />
        )}
        <InfoIcon sx={{ verticalAlign: "middle", marginTop: "-5px" }} />
        <Typography variant="h6" component="span" sx={{ ml: 1 }}>
          <b>{runName}</b>
        </Typography>
      </CardContent>
      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        <CardContent
          sx={{
            paddingBottom: "5px !important",
            padding: "3px",
            mb: "0px",
            mt: "0px",
            cursor: "pointer",
            ":hover": { backgroundColor: "#f7f7f7" },
            // borderBottom: "1px solid #e7e7e7",
          }}
        >
          <Grid container>
            <Grid item container direction="column" xs={6}>
              {right.map((r) => (
                <Grid item container key={r[0]}>
                  <Grid item>
                    <Typography variant="body1" component="span" sx={{ fontWeight: "bold" }}>
                      {r[0]}:&nbsp;
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography sx={{ fontSize: "12pt" }} component="span">
                      {r[1] || "-"}
                    </Typography>
                  </Grid>
                </Grid>
              ))}
            </Grid>
            <Grid item container direction="column" xs={6}>
              {left.map((l) => (
                <Grid item container key={l[0]}>
                  <Grid item>
                    <Typography variant="body1" component="span" sx={{ fontWeight: "bold" }}>
                      {l[0]}:&nbsp;
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography component="span">{l[1] || "-"}</Typography>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </CardContent>
      </Collapse>
    </Card>
  )
}
